import type {InjectionKey, Ref} from 'vue'

export const KEY_IS_MOBILE: InjectionKey<Ref<boolean>> = Symbol('keyIsMobile')
